exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5dc7621a] .el-tabs__header{margin-bottom:0}", ""]);

// exports
